// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Ne-9","bg":"_2wkLQ","shd":"yamvR","left":"_2jWUT","right":"_2Hau9"};